import { useShowCampaignById_new } from '@givebacks/api/store';
import { toTitleCase } from 'core/Utils';
import { DatePickerInput, NumberInput, SimpleGrid, Tooltip } from 'ui';
import { IconInfo } from 'ui/Icons';

import { useCrowdfundingProvider } from '../../../Context';
import { useActivityLogForm } from '../modals/LogActivityModal/LogActivityModalFlow';

type LogActivityFormType = {
  value?: number;
  date?: Date;
};

const LogActivityForm = () => {
  const { campaignId, causeId } = useCrowdfundingProvider();

  const { data: campaign } = useShowCampaignById_new({
    campaignId,
    causeId,
  });

  const form = useActivityLogForm();

  if (campaign?.__type !== 'athon') return null;

  return (
    <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
      <NumberInput
        required
        label={`Number of ${toTitleCase(campaign.units_of_activity_plural ?? 'units')}`}
        placeholder="Enter amount"
        allowDecimal={false}
        allowLeadingZeros={false}
        rightSection={
          <Tooltip maw={300} label="Activity amounts must be whole numbers">
            <IconInfo size={16} />
          </Tooltip>
        }
        {...form.getInputProps('value')}
      />
      <DatePickerInput
        required
        label="Date Completed"
        placeholder="Select a date"
        minDate={new Date(campaign?.starting_at ?? '')}
        maxDate={new Date()}
        {...form.getInputProps('date')}
      />
    </SimpleGrid>
  );
};

export { LogActivityForm };
export type { LogActivityFormType };
